export default __webpack_public_path__ + "static/media/rona.fdc47fcf.webp";